<template>
  <v-list-group v-model="active">
    <v-list-tile slot="activator">
      <v-list-tile-title>{{ title }}</v-list-tile-title>
      <v-list-tile-action>
        <v-btn @click="handleAdd" flat small color="primary">
          <v-icon>add</v-icon> add
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile
      v-for="(item, i) in items"
      @click="$emit('display', item)"
      :key="i">
      <v-list-tile-action></v-list-tile-action>
      <v-list-tile-title>
        {{ item.label }}
        <span class="node-id">#{{ item.id }}</span>
      </v-list-tile-title>
    </v-list-tile>
  </v-list-group>
</template>

<script>
export default {
  name: 'item-list',

  props: ['title', 'items'],

  data: () => ({
    active: true
  }),

  methods: {
    handleAdd (ev) {
      ev.stopPropagation()
      this.$emit('add')
    }
  }

}
</script>
